(function ($) {
    var select = $('#service-dropdown');

    select.on('change', function () {
        var me = $(this);

        // data to be updated when content is pulled dynamically. Currently using dummy data for preview.
        if (me.val()) {
            var currentService = me.find(':selected'),
                desc = currentService.attr('data-desc'),
                btnHref = currentService.attr('data-btnhref'),
                btnText = currentService.attr('data-btntext'),
                btnTarget = currentService.attr('data-btnHrefNewWindow');
                if (btnHref.indexOf("?_mid") > 0) {
                    btnHref = btnHref.substring(0, btnHref.indexOf("?"));
                }

            updateMapContent(desc, btnHref, btnText, btnTarget);
        } else {
            updateMapContent();
        }
    })

    $(window).on('load', function () {
        updateMapContent();
    });

    function updateMapContent(desc = '', btnHref = '', btnText = '', btnTarget = '') {
        var selectP = select.closest('p'),
            descP = selectP.next('p');

        if (desc !== '' && btnHref !== '' && btnText !== '' && btnTarget !== '') {
            if (descP.length) {
                var btnP = descP.next('p');

                descP.text(desc);
                btnP.find('a').attr({
                    'href': btnHref,
                    'target': btnTarget === 'true' ? '_blank' : '_self'
                }).text(btnText);
            } else {
                var target = btnTarget === 'true' ? '_blank' : '_self';

                $('<p>' + desc + '</p><p><a href="' + btnHref + '" target="' + target + '" class="defaultButton-Quinary">' + btnText + '</a></p>').insertAfter(selectP);
            }
        } else {
            if (descP.length) {
                var btnP = descP.next('p');

                descP.fadeOut(300, function () {
                    $(this).remove();
                });
                btnP.fadeOut(300, function () {
                    $(this).remove();
                });
            }
        }
    }

    if ($().matchHeight) {
        $('.matchHeight').matchHeight();
    }

    setTimeout(
        function () {
            if ($().matchHeight) {
                $('.newsFeed .dateList_item').matchHeight();
            }
        }, 100
    );

})(jQuery);